export default {
    DEFAULT_USER_TYPE: 'CRM_MEMBER',
    USER_TYPES: {
        CRM_USER: 'CRM_USER',
        CRM_MEMBER: 'CRM_MEMBER',
    },
    USER_TYPES_CONFIG: {
        CRM_USER: {
            FETCH_USER_ENDPOINT: '/admin/users/me',
            LOGIN_ENDPOINT: '/sso/login?auth_driver=crm',
            LOGOUT_ENDPOINT: '/logout?auth_driver=crm',
        },
        CRM_MEMBER: {
            FETCH_USER_ENDPOINT: '/users/me',
            LOGIN_ENDPOINT: '/sso/login?auth_driver=b2b',
            LOGOUT_ENDPOINT: '/logout?auth_driver=b2b',
        },
    },

    FETCH_USER_ENDPOINT: '/users/me',
    LOGIN_ENDPOINT: '/sso/login?auth_driver=b2b',
    LOGOUT_ENDPOINT: '/logout?auth_driver=b2b',
};
